import { TJobItem } from "../../../../features/organization/job/job.type";
import { formatDate, getMonthDayDiff } from "../../../../lib/time";

const ProjectLabel = ({ data }: { data: TJobItem }) => {
  return (
    <div className="grid grid-cols-12 items-center gap-6">
      <div className="col-span-9">
        <h3 className="text-lg font-medium text-header !inline-block break-all whitespace-normal mb-1">
          {data?.job_title}
        </h3>

        <div className="flex items-center gap-4">
          <ul className="flex items-center gap-6">
            <li>
              Job Posted:{" "}
              {data?.created_at ? formatDate(data?.created_at) : "-"}
            </li>
          </ul>

          <div className="flex items-center gap-1.5">
            {/* {data?.status === "posted" && (
              <span className="!px-3 status-link">
                {data?.status === "posted" ? "Open" : undefined}
              </span>
            )} */}
            <span className="!px-3 status-dark">
              {data?.status === "closed" ? "Closed" : "Open"}
            </span>

            <span className="!px-3 status-success">
              Hired ({data?.number_of_people_hired || 0})
            </span>
          </div>
        </div>
      </div>

      <div className="col-span-3">
        <div className=" text-right  text-cyan-500 text-base font-semibold">
          Employee: {data?.number_of_people_hired}
        </div>

        <div className="text-right  text-yellow-600 text-base font-semibold ">
          Duration: {getMonthDayDiff(data?.hiring_started_at as string)}
        </div>
      </div>
    </div>
  );
};

export default ProjectLabel;
